export function Header() {
  return (
    <header className="flex h-[5.5rem] items-center">
      <div className="container mx-auto">
        <img src="/images/atp-logo.svg" alt="Checkout" />
      </div>
    </header>
  );
}
